/**
 * Mock data for authentication service
 */

import {
  User,
  UserRole,
  AuthResponse,
  LoginResponse,
  RegisterResponse,
} from "./auth.types";

// Placeholder avatar as data URI (no external request needed)
const MOCK_AVATAR_PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='150' height='150'%3E%3Crect fill='%23e5e7eb' width='150' height='150'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial, sans-serif' font-size='14' fill='%239ca3af'%3EAvatar%3C/text%3E%3C/svg%3E";

export const mockUser: User = {
  id: "1",
  email: "john.doe@example.com",
  firstName: "John",
  lastName: "Doe",
  avatar: MOCK_AVATAR_PLACEHOLDER,
  role: UserRole.BUYER,
  companyId: "company-1",
  isActive: true,
  isEmailVerified: true,
  createdAt: "2024-01-01T00:00:00Z",
  updatedAt: "2024-01-01T00:00:00Z",
  lastLoginAt: "2024-01-15T10:30:00Z",
};

export const mockAuthResponse: AuthResponse = {
  user: mockUser,
  accessToken: "mock-access-token-12345",
  refreshToken: "mock-refresh-token-67890",
  expiresIn: 3600,
};

export const mockLoginResponse: LoginResponse = {
  ...mockAuthResponse,
  message: "Login successful",
  success: true,
};

export const mockRegisterResponse: RegisterResponse = {
  ...mockAuthResponse,
  message: "Registration successful",
  success: true,
};

export const mockUsers: User[] = [
  mockUser,
  {
    id: "2",
    email: "jane.smith@example.com",
    firstName: "Jane",
    lastName: "Smith",
    avatar: MOCK_AVATAR_PLACEHOLDER,
    role: UserRole.SELLER,
    companyId: "company-2",
    isActive: true,
    isEmailVerified: true,
    createdAt: "2024-01-02T00:00:00Z",
    updatedAt: "2024-01-02T00:00:00Z",
    lastLoginAt: "2024-01-14T15:45:00Z",
  },
  {
    id: "3",
    email: "admin@example.com",
    firstName: "Admin",
    lastName: "User",
    avatar: MOCK_AVATAR_PLACEHOLDER,
    role: UserRole.ADMIN,
    companyId: "company-1",
    isActive: true,
    isEmailVerified: true,
    createdAt: "2024-01-01T00:00:00Z",
    updatedAt: "2024-01-01T00:00:00Z",
    lastLoginAt: "2024-01-15T09:15:00Z",
  },
];

export const mockAuthError = {
  message: "Invalid credentials",
  success: false,
  status: 401,
  code: "INVALID_CREDENTIALS",
};

export const mockNetworkError = {
  message: "Network error",
  success: false,
  status: 0,
  code: "NETWORK_ERROR",
};
